export enum CollectionStyleItemVariant {
  IN_COLLECTION = "inCollection",
  IN_SEARCH = "inSearch",
  IN_ALL_ITEMS = "inAllItems",
}

export const COLLECTION_SEARCH_PAGE_SIZE = 25;

export const ALL_STYLES_PAGE_SIZE = 25;

export const CIRCULAR_THUMBNAILS_LIMIT = 5;

export const ALL_ITEMS_COLLECTION_ID = "all-items";

export const FIRST_PAGE_ITEMS_LIMIT = 12;

export const ITEMS_PER_PAGE_LIMIT = 8;

export enum CircularThumbnailSize {
  Medium = "medium",
  Large = "large",
}
